import { getValueOfKey } from "./utils/objects.utils";
import { makeUrl } from "./utils/url.utils";
export var isProduction = process.env.NODE_ENV === 'production';
export var isDevelopment = process.env.NODE_ENV === 'development';
export var isInCypressTestMode = Boolean(window.Cypress);
var _SHOULD_LOG = {
    value: isDevelopment
};
export var SHOULD_LOG = function () { return _SHOULD_LOG.value; };
if (localStorage.getItem('SHOULD_LOG') === '8dc01b0de0431cb7eced92277c1f04c7') {
    _SHOULD_LOG.value = true;
}
Object.freeze(_SHOULD_LOG);
var hostname = window.location.hostname;
export var isLocalhost = hostname === 'localhost';
var WP_URL_MAP = Object.freeze({
    'turn2me.ie': 'https://turn2me.ie',
    // 'app.turn2me.ie': 'https://turn2me.ie',
    // 'preflight.turn2me.ie': 'https://wp.turn2me.ie',
    // 'localhost': 'https://wp.turn2me.ie',
    'localhost': 'https://turn2me-v2.test',
    // 'localhost': 'https://localhost:2022',
    'default': 'https://turn2me.ie',
    // 'default': 'https://192.168.0.220:2022',
});
export var WP_URL = (getValueOfKey(hostname, WP_URL_MAP) || WP_URL_MAP.default).replace(/\/+$/, "");
export var getWordPressLink = function (url) {
    return url ? makeUrl(WP_URL, url) : WP_URL;
};
var APP_URL_MAP = Object.freeze({
    'turn2me.ie': 'https://app.turn2me.ie',
    'localhost': 'https://localhost:2020',
    'default': 'https://app.turn2me.ie',
});
export var APP_URL = (getValueOfKey(hostname, APP_URL_MAP) || APP_URL_MAP.default).replace(/\/+$/, "");
export var getAppLink = function (url) {
    return url ? makeUrl(APP_URL, url) : APP_URL;
};
